import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { showAlert } from '../../Helpers/GlobalFunctions';

function SterCaptcha(props, ref) {
    const refCurrentElement = useRef();
    const refParentDivElement = useRef();
    useImperativeHandle(ref, () => { return { fnlProcessCaptcha: fnlProcessCaptcha, ref: refCurrentElement.current } })
    useEffect(() => {
        const fnlLoadInit = async () => {
            await fnlLoad()
        };
        fnlLoadInit();
        return () => {
            //it is called when the component unloading
        }
    }, []);
    async function fnlLoad() {
        await loadCaptchaEnginge(4, 'white', 'black', 'numbers');
        // document.getElementById("reload_href").innerHTML = '<i class="fad fa-sync-alt" title="Reload Captcha"></i>';
        document.querySelector("#" + props.custom.id + " #reload_href").innerHTML = '<i class="fad fa-sync-alt" title="Reload Captcha"></i>';
    }
    const fnlProcessCaptcha = async () => {
        let user_captcha = document.getElementById('user_captcha_input' + props.custom.id).value;
        if (user_captcha !== "") {
            if (validateCaptcha(user_captcha) === true) {
                // alert('Captcha Matched');
                // loadCaptchaEnginge(6);
                // document.getElementById('user_captcha_input').value = "";
                return true;
            }
            else {
                // alert('Captcha Does Not Match');
                showAlert("Captcha Does Not Match", 'info');
                document.getElementById('user_captcha_input' + props.custom.id).value = "";
                return false;
            }
        }
        else {
            showAlert("Enter Captcha Value", 'info');
            return false;
        }
    };
    return (<div>
        <div className="ost-captcha-container">
            <div className="d-flex align-items-center gap-2  flex-wrap flex-auto-catpcha justify-content-end">
                {
                    props.custom.id === "divfootercaptcha_login" ?
                        <React.Fragment>
                            <div className="ost-captcha-canvas d-flex align-items-center justify-content-between">
                                <LoadCanvasTemplate />
                                <input className="form-control form-control-sm" placeholder="Enter Captcha Value" id={"user_captcha_input" + props.custom.id} name="user_captcha_input" type="text"></input>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="ost-captcha-canvas">
                                <LoadCanvasTemplate />
                            </div>
                            <div className="">
                                <div ><input className="form-control form-control-sm" placeholder="Enter Captcha Value" id={"user_captcha_input" + props.custom.id} name="user_captcha_input" type="text"></input></div>
                            </div>

                            {/* <div className="col mt-3">
                        <div><button className="btn btn-primary" onClick={() => this.doSubmit()}>Submit</button></div>
                    </div> */}
                        </React.Fragment>
                }
            </div>

        </div>
    </div>);
}
export default React.forwardRef(SterCaptcha);